var map = {
	"./basicInfo.svg": "wyte",
	"./fileIcon.svg": "Pky5",
	"./monitorBoard.svg": "WVCz",
	"./statistic.svg": "afyG",
	"./truck_fault.svg": "jkjy",
	"./truck_off_line.svg": "houo",
	"./truck_on_line.svg": "4b/t",
	"./videoIcon.svg": "UoH+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 138